<template>
  <div class="wrap">
    <div class="board">
      <div class="key_visual addImg faq">
        <div class="container">
          <p>자주 묻는 질문</p>
        </div>
      </div>

      <div class="board_contents">
        <div class="container">
          <div class="cat_select">
            <ul>
              <li :class="{ on: selectedCategory === '전체' }">
                <router-link :to="{ query: { cat: '전체' } }">전체</router-link>
              </li>
              <li :class="{ on: selectedCategory === '일반' }">
                <router-link :to="{ query: { cat: '일반' } }">일반</router-link>
              </li>
              <li :class="{ on: selectedCategory === '서비스/기능' }">
                <router-link :to="{ query: { cat: '서비스/기능' } }"
                  >서비스/기능</router-link
                >
              </li>
              <li :class="{ on: selectedCategory === '거래' }">
                <router-link :to="{ query: { cat: '거래' } }">거래</router-link>
              </li>
              <li :class="{ on: selectedCategory === '계정/가입' }">
                <router-link :to="{ query: { cat: '계정/가입' } }"
                  >계정/가입</router-link
                >
              </li>
              <li :class="{ on: selectedCategory === '기타' }">
                <router-link :to="{ query: { cat: '기타' } }">기타</router-link>
              </li>
            </ul>
          </div>

          <table class="bbs_table_1 recruit faq_tb">
            <colgroup>
              <col width="20%" />
              <col width="70%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <th>구분</th>
              <th colspan="2">제목</th>
            </thead>
            <tbody
              v-for="(item, index) in filteredFaqData"
              id="dataTbody"
              :key="index"
            >
              <!-- <tbody id="dataTbody" v-for="(item, index) in faqData" :key="index"> -->
              <tr
                :class="{ item: true, on: selectedItemIndex === index }"
                @click="toggleDescription(index)"
              >
                <td v-html="item.category"></td>
                <td class="text_left" v-html="item.title"></td>
                <!-- <td @click="toggleDescription(index)"><img src="../../public/assets/images/icon/bbs_faq_down_icon.png"></td> -->
                <td @click="toggleDescription(index)">
                  <!-- <img
                    src="../../public/assets/images/icon/bbs_faq_down_icon_2.png"
                  /> -->
                  <img
                    src="../assets/images/icon/bbs_faq_down_icon_2.png"
                    @click="toggleDescription(index)"
                  />
                </td>
              </tr>
              <tr
                v-if="selectedItemIndex === index"
                :class="{
                  faq_content: true,
                  hide: !hideorshow,
                  show: hideorshow,
                }"
              >
                <td></td>
                <!-- <td colspan="2" v-html="item.description"></td> -->
                <td colspan="2" v-html="item.formattedDescription"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { loadfaq } from '../api/boards'

export default {
  name: 'FaqViews',
  setup() {
    const route = useRoute()
    const faqData = ref([])
    const hideorshow = ref(false)
    const selectedItemIndex = ref(null)
    const selectedCategory = ref(route.query.cat || '전체') // 기본 카테고리 '전체'

    const getData = async () => {
      const response = await loadfaq()
      if (response.status_code === 200) {
        faqData.value = response.content.map((item) => ({
          ...item,
          // description의 줄바꿈을 <br>로 변환하여 formattedDescription에 저장
          formattedDescription: item.description.replace(/\r\n|\n|\r/g, '<br>'),
        }))
      }
    }
    // const getData = async () => {
    //   const response = await loadfaq()
    //   console.log(response.content)
    //   if (response.status_code === 200) {
    //     faqData.value = response.content.map((item) => ({ ...item }))
    //   }
    // }

    const toggleDescription = (index) => {
      if (selectedItemIndex.value === index) {
        hideorshow.value = !hideorshow.value
      } else {
        hideorshow.value = true
      }
      selectedItemIndex.value = selectedItemIndex.value === index ? null : index
    }
    // 선택된 카테고리에 따라 필터링된 데이터 계산
    const filteredFaqData = computed(() => {
      if (selectedCategory.value === '전체') {
        return faqData.value
      }
      // `selectedCategory` 값이 category 값과 정확히 일치하는지 확인
      return faqData.value.filter(
        (item) => item.category === selectedCategory.value
      )
    })

    // 카테고리 변경 감지
    watch(
      () => route.query.cat,
      (newCategory) => {
        selectedCategory.value = newCategory || '전체'
      },
      { immediate: true }
    )

    onMounted(() => {
      getData()
    })

    return {
      faqData,
      hideorshow,
      selectedItemIndex,
      getData,
      toggleDescription,

      filteredFaqData,
      selectedCategory,
    }
  },
}
</script>

<!-- <script>
import { loadfaq } from '../api/boards';

export default{
  name: 'FaqViews',
  data() {
    return {
      faqData: [],
      hideorshow: false,
      selectedItemIndex: null,
    };
  },
  
  methods: {
    async getData() {
      const response = await loadfaq();
      if (response.status_code === 200) {
        this.faqData = response.content.map((item) => ({ ...item }));
      }
    },
    toggleDescription(index) {
      if (this.selectedItemIndex === index) {
        this.hideorshow = !this.hideorshow;
      } else {
        this.hideorshow = true;
      }
      this.selectedItemIndex = this.selectedItemIndex === index ? null : index;
    },
  },
  
  mounted() {
    this.getData();
  },
};
</script> -->
